<template>
    <div class="file_upload btn elevation-2" :class="{'btn--disabled': disabled}" ripple>
        <div class="btn__content">
            <input type="file" ref="filesInput" multiple @change="changed($event.target.files);">
            <v-icon left>fa-paperclip</v-icon>Anexar Arquivos
        </div>
    </div>
</template>

<script>
import File from './File';

export default {
    props: {
        model: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            files: this.model,
        };
    },
    watch: {
        files(val) {
            this.$emit('update:model', val);
        },
        model(val) {
            this.files = val;
        },
    },
    methods: {
        changed(files) {
            /* Adding files is asynchronous, don't count on this.files.length
             * to impose a limit as it fails when adding 6 or more files at the
             * same time
             */
            let quantity = this.files.length;

            for (let i = 0; i < files.length; i++) {
                const file = files[i];

                if (this.isAboveFileLimit(quantity)) return;

                if (!this.isRepeated(file) &&
                    !this.isAboveSizeLimit(file) &&
                    !this.isEmptyFile(file)) {
                    this.load(file);
                    quantity++;
                }
            }

            this.$refs.filesInput.value = '';
        },
        load(file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (e) => {
                this.files.push({
                    fileName: file.name,
                    contentLength: file.size,
                    contentType: file.type,
                    content: e.target.result,
                    isNewFile: true,
                });
            };
        },
        isAboveFileLimit(quantity) {
            if (quantity >= 5) {
                this.$store.dispatch('showError', this.$t('message.error.attachmentsQuantity'));
                return true;
            }

            return false;
        },
        isAboveSizeLimit({ size }) {
            if (size / 1024 / 1024 > 5) {
                this.$store.dispatch('showError', this.$t('message.error.attachmentsSize'));
                return true;
            }

            return false;
        },
        isEmptyFile({ size }) {
            if (size === 0) {
                this.$store.dispatch('showError', this.$t('message.error.attachmentsEmpty'));
                return true;
            }

            return false;
        },
        isRepeated({ name }) {
            return this.files.find(item => item.fileName.toLowerCase() === name.toLowerCase());
        },
    },
    components: {
        appFile: File,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/FileUpload.vue